import React, { useMemo } from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { intraCuHandoverSuccessNrCellChartConfig } from '../cellChartConfigs';

/**
 * Props for the IntraCuHandoverSuccessNrCell component
 */
interface IntraCuHandoverSuccessNrCellProps {
  /** Name of the NR cell */
  cellName: string;
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * Intra CU Handover Success Rate Chart (NR Cell Level)
 * 
 * Displays Intra-Centralized Unit handover metrics for individual NR cells:
 * - Intra CU Handover Success (count)
 * - Intra CU Handover Attempt (count)
 * - Intra CU Handover Success Rate (percentage)
 * 
 * @component
 * @see {@link ../cellChartConfigs.ts} - Chart configuration (intraCuHandoverSuccessNrCellChartConfig)
 * @see API: /api/nr/cell/intra-cu-handover?cell_name={cellName}
 */

const IntraCuHandoverSuccessNrCell: React.FC<IntraCuHandoverSuccessNrCellProps> = ({ 
  cellName, 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  // Memoize additionalParams to prevent infinite re-renders
  const additionalParams = useMemo(() => ({ cell_name: cellName }), [cellName]);

  return (
    <SiteCharts 
      config={intraCuHandoverSuccessNrCellChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
      additionalParams={additionalParams}
    />
  );
};

export default IntraCuHandoverSuccessNrCell;
